import styled from 'styled-components';

import { BackButton } from '@components/web/src/atoms/Buttons/BackButton/BackButton';
import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { Text } from '@components/web/src/foundations/Text/Text';
import { COLORS, GRADIENTS } from '@components/web/src/styles';

export const ProductFeedbackStartPageContainer = styled(Flexbox)<{ $isTimer?: boolean }>`
  position: relative;
  background: ${GRADIENTS.primaryGradient};
  padding: ${({ $isTimer }) => ($isTimer ? '0' : '0 0 32px')};
  flex: 1;
`;

export const StyledBackButton = styled(BackButton)`
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: ${COLORS.base.white};
  box-sizing: border-box;
  width: 100%;
  padding: 14px;
`;

export const TitleText = styled(Text)`
  color: ${COLORS.gray[25]};
  -webkit-text-stroke-width: 6px;
  -webkit-text-stroke-color: #338e9a;
  paint-order: stroke fill;
  text-shadow:
    0 9px 9px #3d80c1,
    0 6px 13px #24a360;
`;

export const Header = styled(Flexbox)`
  color: ${COLORS.base.white};
  width: 100%;
  text-align: center;
  padding: 32px 15px 16px;
  gap: 16px;
  align-items: center;
  flex-direction: column;
`;

export const ProductDetails = styled(Flexbox)`
  text-align: center;
  padding: 47.96px 16px 8px;
  flex: 1;
  & h3,
  & p {
    margin: 0;
  }
`;

export const CountdownContainer = styled(Flexbox)`
  color: ${COLORS.base.white};
  text-align: center;
  height: 100%;
`;

export const NumberContainer = styled.div`
  span {
    font-size: 120px;
    line-height: 200px;
  }
`;
